@if (order$ | async; as order) {
  <!-- unconsigned entries OR any entries -->
  @if (order?.entries) {
    <div class="frame">
      <div class="cx-list row">
        <div class="col-12 c-list-items-header">
          <p class="c-list-items-header-text">
            {{ 'orderHistoryCustom.myAccount.orderDetails.orderItems' | cxTranslate }}
          </p>
        </div>
        <div class="cx-list-item col-12">
          @if (order.entries.length>0) {
            <app-efa-cart-item-list [items]="order.entries"
              [readonly]="true"
              [isOrderDetails]="true"
            [promotionLocation]="promotionLocation"></app-efa-cart-item-list>
          } @else {
            <app-no-display-result-notice
            noticeHeadline="{{ 'orderHistoryCustom.positionList.empty' | cxTranslate }}"></app-no-display-result-notice>
          }
        </div>
      </div>
    </div>
  }
}
